import { Dispatch } from 'react'

import { RequestContext } from '@cash-web/protos/squareup/franklin/RequestContextProto.pb'
import { CashRequest, CashRequestMiddleware } from '@cash-web/shared-util-fetch'

import { FlowReducerAction, FlowState } from '../../hooks/flowReducer'

const FLOW_TOKEN_HEADER = 'Cash-Flow-Token'
const CLIENT_SCENARIO_HEADER = 'Cash-Client-Scenario'
export const createFlowRequestMiddleware = ({
  state,
}: {
  state: FlowState
  dispatch: Dispatch<FlowReducerAction>
}): CashRequestMiddleware => {
  return (request: CashRequest<{ request_context?: RequestContext }>, context) => {
    // we only want to apply this middleware to non-GET requests
    if (request.method === 'GET') {
      return request
    }

    const headers = request.headers as Record<string, string>
    // add client scenario header
    const clientScenario = context?.options?.clientScenario ?? state.clientScenario
    if (clientScenario != null) {
      headers[CLIENT_SCENARIO_HEADER] = clientScenario
    }

    // add flow token header
    const flowToken = context?.options?.flowToken ?? state.flowToken
    if (flowToken != null && headers[FLOW_TOKEN_HEADER] == null) {
      headers[FLOW_TOKEN_HEADER] = flowToken
    }

    const request_context = request?.data?.request_context ?? ({} as RequestContext)
    // add blocker descriptor id to request context
    if (state.activeBlockerDescriptor?.id != null) {
      request_context.blocker_descriptor_id = state.activeBlockerDescriptor?.id
    }
    // add payment tokens to request context
    if (state.paymentTokens != null) {
      request_context.payment_tokens = state.paymentTokens
    }
    // add transfer token to request context
    if (state.transferToken != null) {
      request_context.transfer_token = state.transferToken
    }

    if (Object.keys(request_context).length > 0 || (typeof window !== 'undefined' && window.csrfToken != null)) {
      request.data ??= {}
      request.data.request_context = request_context
    }

    return request
  }
}
